import React from 'react';
import RoutesNav from '../../components/RoutesNav';
import Logos from '../../components/Logos';

import { Link } from "react-router-dom";

import axios from 'axios';

import { token, host } from '../../assets/options';

class Home extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);

        this.state = {
            img: '',
            partners: [],
            text: '',
            isVideo: false,
            email: ""
        }
    }

    componentDidMount () {
        this._isMounted = true;

        axios.post(host + '/api/home/', {}, {headers: {'authorization': token}})
        .then(res => {
            if (res.status === 200) {
                if(this._isMounted)
                    this.setState({
                        partners: res.data.data.partners,
                        img: res.data.data.img,
                        text: res.data.data.text,
                        email: res.data.email,
                        isVideo: res.data.data.img.split('.')[res.data.data.img.split('.').length - 1] === 'mp4'?true:false
                    });
            } else {
              const error = new Error(res.data.error);
              throw error;
            }
          })
        .catch(err => console.error(err.response ? err.response.data.error : err)); 
    }
    
    componentWillUnmount () {
        this._isMounted = false;
    }

    render () {
        return (
            <React.Fragment>
                <div className="My-Container sef" style={{backgroundImage: `url(${this.state.img !== '' && !this.state.isVideo?`${host}/public/uploads/${this.state.img}`:''})`}}>
                    {/* <div className="BurgerMenu">
                            <div></div>
                            <div></div>
                            <div></div>
                    </div>  */}
                    
                    <Link to="/" className="My_Logo My_Logo--home"></Link>

                    <div className="Container_Texts">
                        <p className="Aygi_title">Այգի</p>
                    </div>

                    <RoutesNav class={'Routing_nav  HomePageNav'} />

                    {this.state.isVideo ? <video className="bgVideo" ref={el=>this.video = el} style={{width: '100%'}} playsInline autoPlay loop muted>
                        <source src={`${host}/public/uploads/${this.state.img}`} type="video/mp4" />
                    </video> : null}
                </div>
                
                <div className="My-Container cnt2" id="MediaFix">
                    {/* <h3 className="txt_a">
                        Ծրագրի մասին
                    </h3> */}
                    <div className="About_text_container" dangerouslySetInnerHTML={{__html: this.state.text}}>
                    </div>

                    <Logos />
                    
                    <div className="My-Footer">
                        <div className="Footer_Container">
                            <div className="Footer_Logo"></div>
                            <div className="footer_texts_block">
                                <div className="Footer_adress">{this.state.email.split("|")[2]}</div>
                                <div className="Footer_Contacts">{this.state.email.split("|")[1]}</div>
                                <div className="Footer_Contacts">{this.state.email.split("|")[0]}</div>
                            </div>
                        </div>
                        <div className="Mini_f">
                            <span>© {new Date().getFullYear()} AYGI</span> <span>Made by <a href="https://weflex.am/" rel="noopener noreferrer" target="_blank" rel="noopener noreferrer">WeFlex</a></span>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Home;